var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label-width":_vm.itemRender.width,"label":`${_vm.itemRender.label}${
    _vm.itemRender.unit ? `(${_vm.itemRender.unit})` : ''
  }`,"required":_vm.itemRender.required ? true : false}},[_c('el-input',{attrs:{"disabled":"","placeholder":_vm.itemRender.placeholder || '请输入'},on:{"input":(val) => {
        _vm.itemRender.value = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      }},model:{value:(_vm.itemRender.value),callback:function ($$v) {_vm.$set(_vm.itemRender, "value", $$v)},expression:"itemRender.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }